import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "./Layout";
import HomePage from "./pages/HomePage";
import ApplicationsPage from "./pages/ApplicationsPage";
import AdmissionsOfficePage from "./pages/AdmissionsOfficePage";
import AdmissionsOfficeDatabasePage from "./pages/ApplicationsDatabasePage";
import LoginPage from "./pages/LoginPage";
import UserPage from "./pages/UserPage";
import OfficeAccountingPage from "./pages/OfficeAccounting";
import DocumentsQRCodePage from "./pages/DocumentsQRCodePage";
import TasksPage from "./pages/TasksPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        element: <HomePage />,
        index: true,
      },
      {
        element: <ApplicationsPage />,
        path: "/applications",
      },
      {
        element: <TasksPage />,
        path: "/tasks",
      },
      {
        element: <Navigate to="/admissions-office/malta/admission" replace />,
        path: "/admissions-office",
      },
      {
        element: <AdmissionsOfficePage />,
        path: "/admissions-office/fr/:country/:document",
      },
      {
        element: <AdmissionsOfficePage />,
        path: "/admissions-office/de/:country/:document",
      },
      {
        element: <AdmissionsOfficePage />,
        path: "/admissions-office/:country/:document",
      },
      {
        element: <AdmissionsOfficeDatabasePage />,
        path: "/admissions-office-database",
      },
      {
        element: <OfficeAccountingPage />,
        path: "/office-accounting",
      },
      {
        element: <DocumentsQRCodePage />,
        path: "/documents-qr-code",
      },
      {
        element: <LoginPage />,
        path: "/login",
      },
      {
        element: <UserPage />,
        path: "/user",
      },
    ],
  },
]);

export default router;
